import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";

export function NotFoundPage() {
  return (
    <Layout>
      <Seo title="Page not found" description="The requested Operandi Studio page could not be found." />
      <section className="flex min-h-screen items-center justify-center px-6 pt-24">
        <div className="max-w-xl text-center" data-testid="not-found-page">
          <p className="font-mono text-xs uppercase tracking-[0.24em] text-amber-700">404</p>
          <h1 className="mt-4 font-heading text-4xl font-extrabold tracking-tight">This page is off the workbench.</h1>
          <p className="mt-4 text-[#525866]">The link may be old, or the page may have been moved.</p>
          <Button asChild className="mt-8 rounded-full bg-[#111315] text-white" data-testid="not-found-home-button"><Link to="/">Return home</Link></Button>
        </div>
      </section>
    </Layout>
  );
}
